// Entry point for the IIFE build (script tag consumers)
export { QuerriEmbed } from './querri-embed.js';
